import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "activitySelectionWrapper",
  class: "flex-col view-wrapper"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "page-title" }, "Select Experiences", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "flex-col as-content"
}
const _hoisted_6 = { id: "activities" }
const _hoisted_7 = { class: "form-flex" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "flex-col try-again"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "We’re having trouble locating your order. Please refresh to try again.", -1)
const _hoisted_11 = { class: "form-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_activity_card = _resolveComponent("activity-card")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
          }),
          _hoisted_3,
          (_ctx.activities.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Select which experiences apply:"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.activities.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (a) => {
                  return (_openBlock(), _createBlock(_component_activity_card, {
                    key: a.OrderEntityTimeKey,
                    activity: a
                  }, null, 8, ["activity"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "form-submit-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onContinue())),
                  disabled: _ctx.disableContinue
                }, _toDisplayString(_ctx.isEditing ? 'Submit' : 'Next'), 9, _hoisted_8)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "form-submit-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getOrderActivities()))
                }, "Refresh")
              ])
            ]))
      ]))
}